
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mapa-stranek",
      function () {
        return require("private-next-pages/mapa-stranek.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mapa-stranek"])
      });
    }
  